import React from "react";

const LOGO_URL = "/logo-transparent.png";

/**
 * MyHandyHub logo.
 *
 * The new logo image contains the icon + "MyHandyHub" wordmark + tagline,
 * so we render it as a single image and scale by height.
 */
export default function Logo({ size = 56, className = "", withWordmark = true }) {
  // `withWordmark` kept for backward-compat but ignored — the new image is self-contained.
  return (
    <span className={`inline-flex items-center ${className}`} data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="MyHandyHub — Fixing today, improving tomorrow"
        style={{
          height: size,
          width: "auto",
          objectFit: "contain",
          display: "block",
        }}
        loading="eager"
      />
    </span>
  );
}
